<template>
  <section id="Categoria" class="categorias">
    <h2 class="titulo">📚 Categorías</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriasView',
  data() {
    return {
      categorias: [
        {
          titulo: 'iPhone de Apple',
          icono: require('@/assets/icons/apple.svg'),
          descripcion: 'Reparaciones y guías de desmontaje para todos los modelos de iPhone, desde los más antiguos hasta los más modernos.'
        },
        {
          titulo: 'Android (General)',
          icono: require('@/assets/icons/android.svg'),
          descripcion: 'Guías de reparación para múltiples dispositivos Android de diferentes marcas y modelos.'
        },
        {
          titulo: 'Xiaomi',
          icono: require('@/assets/icons/xiaomi.svg'),
          descripcion: 'Reparación de smartphones Xiaomi: baterías, pantallas, cámaras y más.'
        },
        {
          titulo: '',
          icono: require('@/assets/icons/tecno.png'),
          descripcion: 'Guías de reparación para dispositivos Tecno Mobile: soluciones rápidas y efectivas.'
        },
        {
          icono: require('@/assets/icons/motorola.svg'),
          descripcion: 'Reparaciones comunes de Motorola: pantallas rotas, puertos de carga y fallos de software.'
        },
        {
    
          icono: require('@/assets/icons/sansung.png'),
          descripcion: 'Soporte para Samsung Galaxy y otros modelos: cambio de pantallas, baterías y más.'
        },
        {
      
          icono: require('@/assets/icons/huawei.svg'),
          descripcion: 'Guías de desmontaje y reparación para dispositivos Huawei y Honor.'
        },
        {

  icono: require('@/assets/icons/honor.svg'), 
  descripcion: 'Guías de desmontaje y reparación para dispositivos Honor, incluyendo modelos recientes y clásicos.'
},
{
  titulo: 'ZTE',
  icono: require('@/assets/icons/zte.png'), 
  descripcion: 'Guías de desmontaje, reparación y mantenimiento para dispositivos ZTE, incluyendo smartphones y equipos de red.'
},
{

  icono: require('@/assets/icons/realme.png'),
  descripcion: 'Guías de desmontaje, reparación y mantenimiento para dispositivos Realme, incluyendo smartphones y accesorios.'
},
{
  icono: require('@/assets/icons/sony.png'), 
  descripcion: 'Guías de desmontaje, reparación y mantenimiento para dispositivos Sony, incluyendo smartphones, consolas y accesorios.'
},


        {
          titulo: 'Accesorios',
          icono: require('@/assets/icons/gear.png'),
          descripcion: 'Soluciones para auriculares, cargadores, cables y otros accesorios móviles.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.categorias {
  background: url('@/assets/Img/Banners/keyboard-blur.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}

.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:nth-child(1) { animation-delay: 0.1s; }
.card-categoria:nth-child(2) { animation-delay: 0.2s; }
.card-categoria:nth-child(3) { animation-delay: 0.3s; }
.card-categoria:nth-child(4) { animation-delay: 0.4s; }
.card-categoria:nth-child(5) { animation-delay: 0.5s; }
.card-categoria:nth-child(6) { animation-delay: 0.6s; }
.card-categoria:nth-child(7) { animation-delay: 0.7s; }
.card-categoria:nth-child(8) { animation-delay: 0.8s; }

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

/* ✅ Efecto zoom al pasar el mouse sobre el icono */
.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
